import axios from "axios";
import queryString from "query-string";

const api = axios.create({
  baseURL: Config.apiUrl,
});

export const setJwt = (token: string | undefined) => {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common.Authorization;
  }
};

export const getRequest = <TRes>(url: string) => {
  return api.get<TRes>(url).then((response) => response.data);
};

export const getPageRequest = async <TRes>(
  url: string,
  page: number,
  size: number,
) => {
  return api
    .get<TRes>(
      queryString.stringifyUrl({
        url: url,
        query: { page: page - 1, size },
      }),
    )
    .then((response) => response.data);
};

export const deleteRequest = (url: string) => {
  return api.delete(url);
};

export const postRequest = (url: string) => {
  return api.post(url);
};

export const postRequestData = (url: string, data: FormData) => {
  return api.post(url, data);
};
